import { getTaxesTextPair } from './chunk-OMVDHYS5.mjs';
import { menuCategoryCardFactory } from './chunk-GXIVGGRP.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/mainScreenTables/menuCategoriesTableFactory.ts
var menuCategoriesTableFactoryCore = (categories, subcategories, taxes) => {
  return Object.values(categories).map((category) => {
    const categoryCoreCard = menuCategoryCardFactory({
      [category.categoryId]: category
    })[0];
    return __spreadProps(__spreadValues({}, categoryCoreCard), {
      itemCount: category.itemIds.length,
      comboCount: category.comboIds.length,
      subcategories: category.subcategoryIds.length > 0 ? category.subcategoryIds.map((subcategoryId) => subcategories[subcategoryId].name).join(", ") || i18n_config_default.t("menuScreen.categoryMain.table.noSubcategories") : void 0,
      taxes: getTaxesTextPair(category.taxIds, taxes)
    });
  });
};

export { menuCategoriesTableFactoryCore };
